import { useState } from "react"
import { useRouter } from "next/router"
import { Flex, Spacer, Box, List, Link, useDisclosure, Image } from "@chakra-ui/react"
import { FaChevronDown } from "react-icons/fa"
import { useSession, signOut } from "next-auth/react"
import { useGlobalState } from "providers/globalState"
import SocialIcons from "./SocialIcons"
import LogoutModal from "components/login/logoutModal"
import stripeMenu from "config/stripe"

export default function CrfStripe() {
    const { open, onOpen, onClose } = useDisclosure({ defaultIsOpen: false })

    return (
        <Flex className="crf-stripe" h={42} pos="fixed" w="100%" maxW="100%" bg="white" align="center" zIndex={1201}>
            <Box ml="15px" mr="5">
                <Image src="/CRF16-Logo-simple-RGB-70px.png" alt="CRF Logo" />
            </Box>
            <nav role="navigation">
                <Flex as={List.Root} alignItems="center" borderLeft="1px solid #e2e2e2" direction="row">
                    {stripeMenu.sites.map((site, i) => {
                        return (
                            <List.Item
                                key={i}
                                display="flex"
                                alignItems="center"
                                h="42px"
                                borderRight="solid 1px #e2e2e2"
                            >
                                <StyledLink {...site} />
                            </List.Item>
                        )
                    })}
                    <List.Item
                        position="relative"
                        display="flex"
                        alignItems="center"
                        h="42px"
                        borderRight="solid 1px #e2e2e2"
                        onMouseOver={onOpen}
                        onMouseOut={onClose}
                    >
                        <StyledLink
                            label={
                                <>
                                    CRF Meetings <FaChevronDown color="#9d9d9f" size="8" />
                                </>
                            }
                        />
                        <List.Root
                            w={180}
                            zIndex={1000}
                            display={open ? "block" : "none"}
                            position="absolute"
                            top="100%"
                            left={0}
                            pb={1}
                            bgColor="#fff"
                            borderTop="1px solid #e2e2e2"
                            listStyle="none"
                        >
                            {stripeMenu.meetings.map((site, i) => {
                                return (
                                    <List.Item key={i}>
                                        <StyledLink {...site} />
                                    </List.Item>
                                )
                            })}
                        </List.Root>
                    </List.Item>
                </Flex>
            </nav>
            <EditInCmsButton />
            <LogoutButton />
            <Spacer />
            <SocialIcons />
        </Flex>
    )
}

// Shared button styles
const buttonStyles = {
    color: "#333",
    bgColor: "#eee",
    px: 5,
    py: 1,
    fontSize: "14px",
    fontWeight: 600,
    borderRadius: 2,
    _hover: {
        bgColor: "#ddd",
    },
}

function EditInCmsButton() {
    const { data: session } = useSession()
    const { page, site } = useGlobalState()
    const router = useRouter()

    const draftId = router.query?.draftId
    const url =
        `https://admin.crfconferences.com/admin/entries/${page.section}/${page.id}?siteId=${site.meeting.siteId}` +
        (draftId ? `&draftId=${draftId}` : "")

    if (session?.user?.isCmsUser && page?.section) {
        return (
            <Box my={2} ml={4}>
                <Link href={url} target="_blank" _hover={{ textDecoration: "none" }}>
                    <Box {...buttonStyles}>Edit in CMS</Box>
                </Link>
            </Box>
        )
    }

    return null
}

function LogoutButton() {
    const { data: session } = useSession()
    const [isLoggingOut, setIsLoggingOut] = useState(false)

    const handleLogout = async () => {
        setIsLoggingOut(true)
        await signOut({ callbackUrl: "/" })
    }

    if (session?.user?.isLoggedIn) {
        return (
            <>
                <Box my={2} ml={2}>
                    <Box as="button" onClick={handleLogout} {...buttonStyles}>
                        Logout
                    </Box>
                </Box>
                {isLoggingOut && <LogoutModal />}
            </>
        )
    }

    return null
}

function StyledLink({ url, label }) {
    return (
        <Link
            href={url}
            p={2}
            color="#9d9d9f"
            fontSize="12px"
            target="_blank"
            lineHeight={"15px"}
            display={"block"}
            _hover={{
                color: "#ed2638",
                textDecoration: "none",
            }}
        >
            {label}
        </Link>
    )
}
